/* GP search drawer (09.10.2026) — see sections/gp-search-drawer.liquid */
(function () {
  if (window.__gpSearch) return;
  window.__gpSearch = true;

  var RECENT_KEY = 'gp_recent_searches';
  var RECENT_MAX = 6;
  var DEBOUNCE = 160;

  function init() {
    var root = document.getElementById('gp-search');
    if (!root) return;
    // Move to <body> so no transformed/sticky header ancestor can clip the fixed overlay.
    if (root.parentElement !== document.body) document.body.appendChild(root);

    var form = root.querySelector('[data-gps-form]');
    var input = root.querySelector('[data-gps-input]');
    var idle = root.querySelector('[data-gps-idle]');
    var results = root.querySelector('[data-gps-results]');
    var body = root.querySelector('[data-gps-body]');
    var clearBtn = root.querySelector('[data-gps-clear]');
    var ghostTyped = root.querySelector('[data-gps-ghost-typed]');
    var ghostRest = root.querySelector('[data-gps-ghost-rest]');
    var recentBox = root.querySelector('[data-gps-recent]');
    var recentList = root.querySelector('[data-gps-recent-list]');
    var popular = root.querySelector('[data-gps-popular]');
    var suggestUrl = root.getAttribute('data-suggest-url') || '/search/suggest';

    var cache = {};
    var timer = null;
    var controller = null;
    var ghost = '';
    var activeIndex = -1;
    var lastOpener = null;
    var lastTerm = '';
    var hideTimer = null;

    /* ---------- open / close ---------- */
    function open(opener, prefill) {
      lastOpener = opener || document.activeElement;
      clearTimeout(hideTimer);
      root.hidden = false;
      document.documentElement.classList.add('gps-lock');
      if (typeof prefill === 'string' && prefill && !input.value) {
        input.value = prefill;
        onInput();
      }
      // Focus synchronously inside the user gesture so iOS opens the keyboard.
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      void root.offsetWidth; // commit the hidden state so the fade-in transition runs
      root.classList.add('is-open');
      renderRecent();
    }

    function close() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('gps-lock');
      input.blur();
      hideTimer = setTimeout(function () { root.hidden = true; }, 200);
      if (lastOpener && lastOpener.focus && !lastOpener.hasAttribute('readonly')) {
        try { lastOpener.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-gp-search-open]');
      if (opener) {
        e.preventDefault();
        open(opener, opener.value);
      }
    });
    // Mobile header bar is a readonly input: open on focus too (keyboard users tabbing in).
    document.querySelectorAll('input[data-gp-search-open]').forEach(function (el) {
      el.addEventListener('focus', function () { if (root.hidden) open(el); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === '/' && root.hidden && !/input|textarea|select/i.test(document.activeElement.tagName) && !document.activeElement.isContentEditable) {
        e.preventDefault();
        open(null);
      }
    });

    root.querySelectorAll('[data-gps-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    /* ---------- recent searches ---------- */
    function loadRecent() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
    }
    function saveRecent(term) {
      term = (term || '').trim();
      if (term.length < 2) return;
      var list = loadRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); } catch (e) {}
    }
    function renderRecent() {
      if (!recentBox) return;
      var list = loadRecent();
      recentList.innerHTML = '';
      list.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gps-chip gps-chip--recent';
        b.setAttribute('data-gps-term', t);
        b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 7v5l3 2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        b.appendChild(document.createTextNode(t));
        recentList.appendChild(b);
      });
      recentBox.hidden = list.length === 0;
    }

    /* ---------- ghost autocomplete ---------- */
    function setGhost(text) {
      var typed = input.value;
      ghost = '';
      if (text && typed && text.toLowerCase().indexOf(typed.toLowerCase()) === 0 && text.length > typed.length) {
        ghost = typed + text.slice(typed.length);
      }
      ghostTyped.textContent = ghost ? typed : '';
      ghostRest.textContent = ghost ? ghost.slice(typed.length) : '';
    }
    function acceptGhost() {
      if (!ghost) return false;
      input.value = ghost;
      setGhost('');
      onInput();
      return true;
    }

    /* ---------- live search ---------- */
    function showIdle() {
      results.hidden = true;
      results.innerHTML = '';
      idle.hidden = false;
      input.setAttribute('aria-expanded', 'false');
      setActive(-1);
    }

    function render(html, term) {
      if (term !== input.value.trim()) return;
      results.innerHTML = html;
      var wrap = results.querySelector('.gps-results');
      if (!wrap) { showIdle(); return; }
      idle.hidden = true;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      setGhost(wrap.getAttribute('data-gps-ghost'));
      var emptyChips = results.querySelector('[data-gps-empty-chips]');
      if (emptyChips && popular) emptyChips.innerHTML = popular.innerHTML;
      setActive(-1);
      if (term !== lastTerm) body.scrollTop = 0;
      lastTerm = term;
    }

    function fetchResults(term) {
      if (cache[term]) { render(cache[term], term); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      root.classList.add('is-loading');
      var url = suggestUrl + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,query,collection,article,page' +
        '&resources[limit]=8&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag' +
        '&section_id=gp-search-results';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('.shopify-section') || doc.body;
          cache[term] = section.innerHTML;
          root.classList.remove('is-loading');
          render(cache[term], term);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          root.classList.remove('is-loading');
        });
    }

    function onInput() {
      var term = input.value.trim();
      clearBtn.hidden = input.value.length === 0;
      // Keep the ghost while the user is still typing along it.
      if (ghost && ghost.toLowerCase().indexOf(input.value.toLowerCase()) === 0 && input.value) {
        setGhost(ghost);
      } else {
        setGhost('');
      }
      clearTimeout(timer);
      if (!term) {
        if (controller) controller.abort();
        root.classList.remove('is-loading');
        showIdle();
        return;
      }
      timer = setTimeout(function () { fetchResults(term); }, cache[term] ? 0 : DEBOUNCE);
    }

    input.addEventListener('input', onInput);

    clearBtn.addEventListener('click', function () {
      input.value = '';
      onInput();
      input.focus();
    });

    /* ---------- keyboard navigation ---------- */
    function items() {
      var scope = results.hidden ? idle : results;
      return Array.prototype.slice.call(scope.querySelectorAll('[data-gps-item], .gps-chip, .gps-cat')).filter(function (el) {
        return el.offsetParent !== null;
      });
    }
    function setActive(i) {
      var list = items();
      list.forEach(function (el) { el.classList.remove('is-active'); });
      activeIndex = i;
      if (i >= 0 && list[i]) {
        list[i].classList.add('is-active');
        list[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    input.addEventListener('keydown', function (e) {
      var list;
      if (e.key === 'Escape') {
        e.preventDefault();
        if (input.value) { input.value = ''; onInput(); } else { close(); }
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        list = items();
        if (!list.length) return;
        e.preventDefault();
        var next = activeIndex + (e.key === 'ArrowDown' ? 1 : -1);
        if (next < -1) next = list.length - 1;
        if (next >= list.length) next = -1;
        setActive(next);
      } else if (e.key === 'Tab' && !e.shiftKey && ghost) {
        e.preventDefault();
        acceptGhost();
      } else if (e.key === 'ArrowRight' && ghost && input.selectionStart === input.value.length) {
        e.preventDefault();
        acceptGhost();
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        list = items();
        if (list[activeIndex]) {
          e.preventDefault();
          list[activeIndex].click();
        }
      }
    });

    /* ---------- chips, suggestions, saving ---------- */
    root.addEventListener('click', function (e) {
      var term = e.target.closest('[data-gps-term]');
      if (term) {
        e.preventDefault();
        input.value = term.getAttribute('data-gps-term');
        input.focus();
        onInput();
        return;
      }
      if (e.target.closest('[data-gps-recent-clear]')) {
        try { localStorage.removeItem(RECENT_KEY); } catch (x) {}
        renderRecent();
        input.focus();
        return;
      }
      var scroll = e.target.closest('[data-gps-scroll]');
      if (scroll) {
        var rail = root.querySelector('[data-gps-rail]');
        if (rail) rail.scrollBy({ left: Number(scroll.getAttribute('data-gps-scroll')) * rail.clientWidth * 0.8, behavior: 'smooth' });
        return;
      }
      if (e.target.closest('[data-gps-save]') && input.value.trim()) saveRecent(input.value);
    });

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); return; }
      saveRecent(input.value);
    });

    // Back/forward cache: never restore the page with the drawer open.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && !root.hidden) {
        root.classList.remove('is-open');
        root.hidden = true;
        document.documentElement.classList.remove('gps-lock');
      }
    });

    renderRecent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
